import { render, staticRenderFns } from "./PastTreatmentCreatedModal.vue?vue&type=template&id=1c9c5e1e&scoped=true"
import script from "./PastTreatmentCreatedModal.vue?vue&type=script&lang=js"
export * from "./PastTreatmentCreatedModal.vue?vue&type=script&lang=js"
import style0 from "./PastTreatmentCreatedModal.vue?vue&type=style&index=0&id=1c9c5e1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9c5e1e",
  null
  
)

export default component.exports